/**
 * api/regression.js — Frontend client for the SuperAdmin regression framework.
 */
import api from '../lib/api';

const base = '/super-admin/regression';

export const fetchModules = () =>
  api.get(`${base}/modules`).then((r) => r.data);

export const triggerRun = ({ modules = null, includePerf = false } = {}) =>
  api
    .post(`${base}/run`, { modules, include_perf: includePerf })
    .then((r) => r.data);

export const fetchRun = (runId) =>
  api.get(`${base}/runs/${runId}`).then((r) => r.data);

export const fetchRecentRuns = (limit = 25) =>
  api.get(`${base}/runs`, { params: { limit } }).then((r) => r.data);

export const fetchIndexAudit = () =>
  api.get(`${base}/index-audit`).then((r) => r.data);

export const fetchPerfAudit = () =>
  api.get(`${base}/perf-audit`).then((r) => r.data);

export const cleanupRuns = (keepRecent = 50) =>
  api.post(`${base}/cleanup`, null, { params: { keep_recent: keepRecent } }).then((r) => r.data);
